<template>
  <button class="secondary-button" @click="$emit('click')">
    <span class="button-text"><slot /></span>
  </button>
</template>

<script>
export default {
  name: 'SecondaryButton',
}
</script>

<style scoped>
.secondary-button {
  display: flex;
  width: 166px;
  height: 36px;
  /* padding: 15px 120px; */
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;

  border-radius: 8px;
  border: 2px solid var(--primary-color);
  background-color: #fff;
  cursor: pointer;
}

.button-text {
  color: var(--primary-color);
  text-align: center;
  font-family: 'Archivo', sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
  letter-spacing: 0.14px;
}
</style>
